import { Configuration, LogLevel } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_MSAL_CLIENT_ID || '3a79bac2-11f0-4168-a61a-ef3a4c539d0b';
const authority = import.meta.env.VITE_MSAL_AUTHORITY || 'https://login.microsoftonline.com/common';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: [`api://${clientId}/access_as_user`],
};
